<template>
  <div class="wrap1">
    <h1 class="common-title">
      <span>{{ $t('i18n.1c1f025d7046470fbd564b227e97eb36') }}</span>
      <div>
        <template v-if="isEdit">
          <el-button size="small" @click="isEdit = false">{{ $t('66') }}</el-button>
          <el-button size="small" type="primary" @click="handleSave">{{ $t('67') }}</el-button>
        </template>
        <template v-if="$p('menu.settings.privacy-agreement.edit') && !isEdit">
          <el-button size="small" type="primary" @click="isEdit = true">{{
            agreeContent.content || agreeContent.file_url
              ? $t('i18n.e609be792eb74d8d8a64b9255d6b95ce')
              : $t('i18n.80e91bfa5e6b4619a50c91134a0f14ee')
          }}</el-button>
        </template>
      </div>
    </h1>
    <!-- 编辑 -->
    <agreeEdit v-if="isEdit" class="wrap1-box form-box" ref="edit" :content="agreeContent" />
    <!-- 内容 -->
    <div
      v-else
      :class="{
        'wrap1-box': true,
        'wrap1-btn': true,
        'agree-preview': true
      }"
    >
      <template v-if="agreeContent.content || agreeContent.file_url">
        <div>
          <h3>{{ agreeContent.title }}</h3>
          <span class="update-time"
            >{{ $t('i18n.1d766d83f1a0497fa3dbdec73f3429a0') }}{{ agreeContent.created_at }}</span
          >
        </div>
        <div class="agree-content">
          <label>{{ $t('866') }}: </label>
          <div class="w-e-text">
            <div v-if="agreeContent.p_type === '1'" v-dompurify-html="agreeContent.content" class="pa-1"></div>
            <span v-else @click="handleFile(agreeContent.file[0])">{{ agreeContent.file[0].object_url }}</span>
          </div>
        </div>
      </template>

      <div v-else class="not-data">
        {{ $t('i18n.f67558e7ae6b471c9e7f76fc9167d67d') }}
        <template v-if="$p('menu.settings.privacy-agreement.edit')">
          ,
          <el-button size="small" type="text" @click="isEdit = true">{{
            $t('i18n.0325f03a5a6843229a751fb93587520f')
          }}</el-button></template
        >
      </div>
    </div>
    <div
      class="flex-btn"
      v-if="!isEdit && (agreeContent.content || agreeContent.file_url) && $p('menu.settings.privacy-agreement.edit')"
    >
      <el-button type="primary" :loading="loading" :disabled="isRelease" @click="handleRelease">{{
        $t('i18n.f3974699112e438fa64fbb9d35c790ad')
      }}</el-button>
    </div>
    <!-- 预览 -->
    <agreePreview ref="pre" :content="agreeContent" />
  </div>
</template>
<script>
import agreeEdit from './agreeEdit'
import { getAgreement } from 'api/settings'
import agreePreview from './agreePreview'
import { agreementSave } from 'api/settings'

export default {
  components: {
    agreeEdit,
    agreePreview
  },
  data() {
    return {
      agreeContent: {
        type: '',
        title: this.$t('i18n.cc2205ac932a4b34b31ec3ef16fbd452'),
        created_at: '', // 创建时间
        content: '' // 内容
      },
      loading: false,
      isRelease: true,
      isEdit: false // 是否编辑
    }
  },
  created() {
    this.agreementGet()
  },
  methods: {
    // Mobile 预览
    handlePreview() {
      this.$refs.pre.visible = true
    },
    // handleEdit() {
    //   this.isEdit = true
    // },
    // 获取协议
    async agreementGet() {
      getAgreement().then(({ data }) => {
        const file = data.file_url ? [{ object_url: data.file_url, name: data.file_url }] : []
        data.file = file
        this.agreeContent = data
      })
    },
    // 存储隐私协议
    handleSave() {
      this.isRelease = false
      const edit = this.$refs.edit
      edit.$refs.form.validate(valid => {
        if (valid) {
          this.isEdit = false
          this.agreeContent.file_url = edit.form.file_url
          this.agreeContent.file = edit.form.file_url
            ? [{ object_url: edit.form.file_url, name: edit.form.file_url }]
            : []
          this.agreeContent.content = edit.form.content
          this.agreeContent.p_type = edit.form.p_type
        }
      })
    },
    handleFile(url) {
      window.open(url.object_url)
    },
    // 存储隐私协议
    handleRelease() {
      this.$confirm(this.$t('i18n.bc89546a8ec545b6a40ed44a12356aa6'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(() => {
        this.isRelease = true
        this.loading = true
        agreementSave(this.agreeContent)
          .then(() => {
            this.$message({
              message: this.$t('i18n.0d05a02a8cbd433687acf90829b35fee'),
              type: 'success'
            })
            this.agreementGet()
          })
          .finally(() => (this.loading = false))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.common-title {
  display: flex;
  justify-content: space-between;
}
.wrap1-box {
  h3 {
    color: #262626;
  }
  .update-time {
    color: #595959;
    font-size: 12px;
  }
  .not-data {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
    color: #262626;
    font-weight: 500;
    .el-button {
      font-size: 16px;
    }
  }
}
.agree-content {
  height: calc(100vh - 357px);
  margin-top: 13px;
  display: flex;
  label {
    font-size: 14px;
    padding-right: 5px;
  }
  .w-e-text {
    // background: #f4f4f4;
    // border: 1px solid #d3d5d7;
    height: 100%;
    flex: 1;
    span {
      color: #5D51DA;
      font-size: 14px;
      cursor: pointer;
      word-break: break-word;
    }
  }
  .center {
    padding: 100px 0;
    opacity: 0.2;
    user-select: none;
  }
}
</style>
